import React, { useEffect, useState } from "react";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import Crop from "../../shared/crop"
import 'react-phone-input-2/lib/style.css'
import { toast } from "react-toastify";


const Profile = () => {

    const [id, setId] = useState(null)
    const [imagePreview, setImagePreview] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        address: "",
        city: "",
        state: "",
        pin_code: "",
        gst_no: "",
        pan_no: "",
        website: "",
        location_link: "",
        contact_no: "",
    });

    const SaveProfile = () => {
        let body = { ...formData };
        const pUrl = id ? API_URL.PROFILE_UPDATE : API_URL.PROFILE_SAVE;
        axios.post(pUrl, body).then((res) => {
            if (res.data.status === 1) {
                if (id) {
                    toast.success("Updated", {
                        autoClose: 3000,
                        position: "top-center",
                    });
                } else {
                    toast.success("Saved", { autoClose: 3000, position: "top-center" });
                }
            }
        });
    }

    return (
        <>
            <div className="page-header">
                <div className="content-page-header">
                    <h5>Profile</h5>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className='row'>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="Category">Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            className="form-control"
                                            id="name"
                                            onChange={(event) => {
                                                setFormData({ ...formData, name: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="Category">Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            className="form-control"
                                            id="stock"
                                            onChange={(event) => {
                                                setFormData({ ...formData, email: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="Category">Address</label>
                                        <input
                                            type="text"
                                            name="address"
                                            value={formData.address}
                                            className="form-control"
                                            id="address"
                                            onChange={(event) => {
                                                setFormData({ ...formData, address: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="Category">City</label>
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city}
                                            className="form-control"
                                            id="city"
                                            onChange={(event) => {
                                                setFormData({ ...formData, city: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="name">State</label>
                                        <input
                                            type="text"
                                            name="state"
                                            value={formData.state}
                                            className="form-control"
                                            id="state"
                                            onChange={(event) => {
                                                setFormData({ ...formData, state: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="name">Pin Code</label>
                                        <input
                                            type="number"
                                            name="Pin code"
                                            maxLength={30}
                                            value={formData.pin_code}
                                            className="form-control"
                                            id="Pin code"
                                            onChange={(event) => {
                                                setFormData({ ...formData, pin_code: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="name">GST No</label>
                                        <input
                                            type="text"
                                            name="gst no"
                                            value={formData.gst_no}
                                            className="form-control"
                                            id="gst no"
                                            onChange={(event) => {
                                                setFormData({ ...formData, gst_no: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="name">PAN No</label>
                                        <input
                                            type="text"
                                            name="Pin code"
                                            value={formData.pan_no}
                                            className="form-control"
                                            id="Pin code"
                                            onChange={(event) => {
                                                setFormData({ ...formData, pan_no: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="name">Contact No</label>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <input
                                                disabled
                                                type="text"
                                                name="Pin code"
                                                value={"+91"}
                                                className="form-control"
                                                id="Pin code"
                                            />
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                type="number"
                                                name="Pin code"
                                                maxLength={10}
                                                value={formData.contact_no}
                                                className="form-control"
                                                id="Pin code"
                                                onChange={(event) => {
                                                    setFormData({ ...formData, contact_no: event.target.value });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="name">Website</label>
                                        <input
                                            type="text"
                                            name="website"
                                            value={formData.website}
                                            className="form-control"
                                            id="website"
                                            onChange={(event) => {
                                                setFormData({ ...formData, website: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="name">Location Link</label>
                                        <input
                                            type="text"
                                            name="location link"
                                            value={formData.location_link}
                                            className="form-control"
                                            id="location link"
                                            onChange={(event) => {
                                                setFormData({ ...formData, location_link: event.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="col-md-4">
                                <div className='form-group'>
                                    <label className="form-label">Logo</label>
                                    <Crop imagePreview={imagePreview} cropShape='round' guid={''}
                                        onChangeCropper={async ({ fileCropped, fileCroppedBase64 }) => {
                                            setFormData({ ...formData, image: fileCroppedBase64 })
                                            setImagePreview(fileCroppedBase64);
                                            //   await uploadFile(fileCropped)
                                        }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group text-end">
                                <button
                                    type="submit"
                                    onClick={SaveProfile}
                                    // disabled={!isValidForm()}
                                    className="btn btn-primary"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile